import axios from '@/common/axios'

const BASE_URL = '/api/changelog'

export function getChangelogEntries(page) {
  return axios.get(BASE_URL, { params: { page } })
}

export function getChangelogUnread() {
  return axios.get(`${BASE_URL}/unread`)
}

export function markChangelogViewed() {
  return axios.post(`${BASE_URL}/mark_viewed`)
}

export function setChangelogReaction(entryId, kind) {
  return axios.put(`${BASE_URL}/entries/${entryId}/reaction`, { kind })
}

export function removeChangelogReaction(entryId) {
  return axios.delete(`${BASE_URL}/entries/${entryId}/reaction`)
}
